import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHammer: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="hammer, craft, build"><path d="M5.89405 15.75L1.5 11.33L10.0297 2.75L14.6822 2.75L16.75 4.82997L5.89405 15.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.5 12.5L17.75 20.75L20.75 17.75L12.5 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconHammer;
